import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/app/[locale]/partners/[slug]/partner.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/node_modules/next/dist/client/link.js");
